<template>
  <div class="luckydraw-detail">
    <div class="my-prize">
      <div class="luckydraw-detail-title red">
        My prizes
      </div>
      <div class="my-prize-list">
        <ul v-if="myAwards && myAwards.length > 0">
          <li
            class="my-prize-item"
            v-for="(item, index) in myAwards"
            :key="index"
          >
            <img :src="item.image" class="my-prize-item-image" />
            <div>
              <div class="prize-item-name black">{{ item.title }}</div>
              <div class="prize-item-desc deep-gray">
                {{ item.level }}
              </div>
            </div>
          </li>
        </ul>
        <div class="luckydraw-text-warp" v-else>No winning record</div>
      </div>
    </div>
    <div class="prize-show">
      <div class="luckydraw-detail-title yellow black">
        Activity prizes
      </div>
      <div class="prize-show-list">
        <ul>
          <li
            class="prize-show-item"
            v-for="(item, index) in prizes"
            :key="index"
          >
            <div class="prize-show-item-image">
              <img :src="item.image" />
            </div>
            <div>
              <div class="black">{{ item.title }}</div>
              <div class="deep-gray" style="margin-top:4px">
                {{ item.level }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="luckydraw-other">
      <div class="luckydraw-detail-title yellow black">
        Activity description
      </div>
      <div class="luckydraw-text-warp" v-html="detail.rules"></div>
    </div>
    <div class="luckydraw-other">
      <div class="luckydraw-detail-title yellow black">
        Activity time
      </div>
      <div class="luckydraw-text-warp">
        {{ detail.start_time?detail.start_time.replace(/:00$/g,""):"" }}&nbsp;~&nbsp;{{ detail.end_time?detail.end_time.replace(/:00$/g,""):"" }}
      </div>
    </div>
  </div>
</template>

<script>
import { baseOssUrl } from "@/util/config";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  data() {
    return {
      baseOssUrl,
      baseSize,
      prizes: []
      // defaultPrize: [],
      // prizeReSort: []
    };
  },
  props: {
    detail: {},
    myAwards:[]
  },
  watch:{
    myAwards(newVal){
    }
  },
  mounted() {
    console.log(this.detail)
    if (this.detail && this.detail.prizes && this.detail.prizes.length > 0){
      this.prizes = this.detail.prizes.filter(item => item.id > 0);}
  },
  methods: {}
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.luckydraw-detail {
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding-top: 32px;
  padding-bottom: 40px;
}
.luckydraw-detail-title {
  font-size: 18px;
  border-width: 0;
  border-left-width: 4px;
  border-style: solid;
  padding-left: 12px;
  font-weight: bold;
  &.red {
    border-color: rgb(255, 25, 17);
  }
  &.yellow {
    border-color: #f9df5e;
  }
}

.my-prize-list{
  ul{
    // max-height: 295px;
    // overflow-y: scroll;
    padding-bottom: 4px;
  }
  // &:after{
  //   padding-bottom: 26px;
  //   content: "";
  //   display: block;
  //   border-bottom: 1px solid #ddd;
  //   margin: 0 16px;
  // }
}

.my-prize-item {
  padding: 10px 6px;
  // box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  margin: 0 16px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}
.my-prize-item-image{
  width: 70px;
  height: 70px;
  margin-right: 10px;
}
.prize-item-name {
  font-size: 16px;
  font-weight: bold;
}
.prize-item-desc {
  font-size: 15px;
  margin-top: 4px;
}
.prize-show {
  margin-top: 26px;
}
.prize-show-item {
  display: flex;
  // padding: 0 18px;
  margin: 16px 16px 0;
  align-items: center;
  font-size: 14px;
}
.prize-show-item-image {
  width: 92px;
  height: 70px;
  border: 1px solid #eee;
  position: relative;
  overflow: hidden;
  flex-grow: 0;
  margin-right: 10px;
  border-radius: 6px;
  img {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.luckydraw-other {
  margin-top: 26px;
}
.luckydraw-text-warp {
  margin: 16px 16px 0;
  color: #333;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/LuckDraw/PrizeDetail.vue